const VG = {
  iban: {
    bankStatementRequirement: "REQUIRED",
    defaultCurrency: "USD",
    fields: [
      "accountHolder",
      "accountHolderCity",
      "bankCity",
      "bankName",
      "country",
      "iban",
      "swiftCode"
    ]
  }
};
export {
  VG as default
};
